import { useState, useRef } from 'react';
import XTable from 'components/XTable';
import {
    Modal,
    Input,
    notification,
    Switch,
    InputNumber,
    Space,
    Button,
    Row,
    Col,
    Divider,
} from 'antd';
import {
    getAdminListApi,
    postAddAdminApi,
    putEditAdminApi,
    getAdminRoleApi,
    postAddAdminRoleApi,
    delAdminRoleApi,
} from 'api/admin';
import { getRoleListApi } from 'api/authV1';
import XForm from 'components/XForm';
import moment from 'moment';

const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};

const AdminMGT = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const xAdminRolesTableRef = useRef();
    const xRolesTableRef = useRef();
    const [modalVisible, setmodalVisible] = useState(false);
    const [roleVisible, setroleVisible] = useState(false);
    const [roleUsername, setroleUsername] = useState(false);
    const [okBtnLoading, setokBtnLoading] = useState(false);
    const [adminRoles, setadminRoles] = useState([]);
    const [modalType, setmodalType] = useState('');
    const [id, setid] = useState('');

    const showModal = (modalType, data = {}) => {
        const { dept = '', no = '', phone = '', username = '', id = '', status = true } = data;
        setmodalType(modalType);
        setid(id);
        setmodalVisible(true);
        setTimeout(() => {
            xFormRef.current.form?.setFieldsValue({
                dept,
                no,
                phone,
                username,
                status,
                password: '',
            });
        }, 0);
    };

    const showRoleModal = data => {
        const { id } = data;
        getAdminRole(id);
        setid(id);
        setroleUsername(data.username);
        setroleVisible(true);
    };

    const roleModalCancel = () => {
        setid('');
        setroleUsername('');
        setroleVisible(false);
    };

    // 获取所有已设置角色
    const getAdminRole = id => {
        const params = {
            pageSize: 999,
            admin_id: id,
        };
        getAdminRoleApi(params).then(res => {
            if (res.success) {
                const roleIds = (res.list || []).map(item => item.id);
                setadminRoles(roleIds);
            }
        });
    };

    // 添加|移除管理员角色
    const addOrDelAdminRole = (roleId, type) => {
        const params = {
            admin_id: id,
            role_id: roleId,
        };
        const api = type === 'add' ? postAddAdminRoleApi : delAdminRoleApi;
        const tipText = type === 'add' ? '添加' : '移除';
        const isDel = type === 'del';
        api(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `角色${tipText}成功`,
                });
                getAdminRole(id);
                xAdminRolesTableRef.current.refreshTable &&
                    xAdminRolesTableRef.current.refreshTable(isDel);
                xRolesTableRef.current.refreshTable && xRolesTableRef.current.refreshTable();
            }
        });
    };

    // 弹窗确认
    const handelOk = () => {
        xFormRef.current.form?.submit();
    };

    // 弹窗取消
    const handelCancel = () => {
        setmodalVisible(false);
        setid('');
        xFormRef.current.form?.setFieldsValue({
            dept: '',
            no: '',
            password: '',
            phone: '',
            username: '',
            status: true,
        });
    };

    // 执行新增|修改管理员
    const onFinish = values => {
        setokBtnLoading(true);
        let api = null;
        let tipText = '';
        let params = values;
        if (modalType === 'add') {
            api = postAddAdminApi;
            tipText = '新增';
        } else {
            api = putEditAdminApi;
            tipText = '修改';
            params = { ...params, id };
        }
        params = { ...params, password: values.password ? values.password : '' };
        api(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `管理员${tipText}成功。`,
                });
                setmodalVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setokBtnLoading(false);
        });
    };

    const columns = [
        {
            title: '名称',
            dataIndex: 'username',
        },
        {
            title: '工号',
            dataIndex: 'no',
        },
        {
            title: '手机号',
            dataIndex: 'phone',
        },
        {
            title: '部门',
            dataIndex: 'dept',
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: val => {
                return val ? '启用' : '禁用';
            },
        },
        {
            title: '创建时间',
            dataIndex: 'createAt',
            render: val => {
                return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '--';
            },
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, data) => {
                return (
                    <Space size="middle">
                        <span className="actionText" onClick={() => showModal('edit', data)}>
                            修改
                        </span>
                        <span className="actionText" onClick={() => showRoleModal(data)}>
                            设置角色
                        </span>
                    </Space>
                );
            },
        },
    ];
    const actionBtns = [{ text: '新增管理员', onClick: () => showModal('add') }];
    const formItems = [
        {
            formItemApis: {
                label: '名称',
                name: 'username',
                rules: [{ required: true }],
            },
            item: <Input />,
        },
        {
            formItemApis: {
                label: '工号',
                name: 'no',
                rules: [{ required: true }],
            },
            item: <InputNumber min={1001} max={99999} precision={0} style={{ width: '100%' }} />,
        },
        {
            formItemApis: {
                label: '手机号',
                name: 'phone',
                rules: [{ required: true }],
            },
            item: <Input maxLength={11} />,
        },
        {
            formItemApis: {
                label: '部门',
                name: 'dept',
                rules: [
                    { required: true },
                    { pattern: /^\S{2,20}$/, message: '请输入2-20位部门名称' },
                ],
            },
            item: <Input />,
        },
        {
            formItemApis: {
                label: '状态',
                name: 'status',
                valuePropName: 'checked',
                rules: [{ required: true }],
            },
            item: <Switch checkedChildren="启用" unCheckedChildren="禁用" />,
        },
        {
            formItemApis: {
                label: '密码',
                name: 'password',
                rules: [
                    { required: !!(modalType === 'add') },
                    { pattern: /^\S{6,50}$/, message: '请输入6-50位登录密码' },
                ],
            },
            item: <Input placeholder={modalType === 'add' ? '' : '为空则不修改密码。'} />,
        },
    ];
    return (
        <div>
            <XTable
                columns={columns}
                api={getAdminListApi}
                rowKey="id"
                actionBtns={actionBtns}
                ref={xTableRef}
            />
            <Modal
                title={`${modalType === 'add' ? '新增' : '修改'}管理员`}
                centered
                visible={modalVisible}
                onOk={handelOk}
                okButtonProps={{ loading: okBtnLoading }}
                onCancel={handelCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'adminAction',
                        onFinish: onFinish,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
            {id && roleVisible ? (
                <Modal
                    title="设置角色"
                    width={1000}
                    centered
                    visible={roleVisible}
                    footer={[
                        <Button type="primary" onClick={roleModalCancel}>
                            关闭
                        </Button>,
                    ]}
                    onCancel={roleModalCancel}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                {roleUsername}已设置角色
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    { title: '角色id', dataIndex: 'id' },
                                    { title: '角色名称', dataIndex: 'name' },
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        render: (val, data) => {
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelAdminRole(data.id, 'del')
                                                    }>
                                                    移除
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getAdminRoleApi}
                                apiParams={{ admin_id: id }}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xAdminRolesTableRef}
                            />
                        </Col>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                所有角色
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    { title: '角色id', dataIndex: 'id' },
                                    { title: '角色名称', dataIndex: 'name' },
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        render: (val, data) => {
                                            const hasId = (adminRoles || []).includes(data.id);
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelAdminRole(
                                                            data.id,
                                                            hasId ? 'del' : 'add',
                                                        )
                                                    }>
                                                    {hasId ? '移除' : '添加'}
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getRoleListApi}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xRolesTableRef}
                            />
                        </Col>
                    </Row>
                </Modal>
            ) : null}
        </div>
    );
};
export default AdminMGT;
